<div class="remove-auto-cashout">
    <div class="title">
        @if (type === cashoutSettingsType.Auto) {
            <vn-icon class="cashout-icon" name="theme-success-i" size="32" />
        }
        @if (type === cashoutSettingsType.Notify) {
            <vn-icon class="cashout-icon" name="theme-message" size="32" />
        }
    </div>
    <div class="body-text">
        <span class="text">{{ bodyText }}</span>
    </div>
    <div class="body-amount">
        @if (!prependCurrencySymbol) {
            <span class="amount">{{ value }}</span>
            <span class="currency">&nbsp;{{ currency }}</span>
        } @else {
            <span class="amount">{{ getCurrencyWithSymbol }}</span>
        }
    </div>

    <div class="button-wrapper">
        <ms-my-bets-earlypayout-remove-autocashout-button
            [removeType]="type"
            [betNumbers]="betNumbers"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-remove-autocashout-button>
    </div>
</div>
